import { SVGProps, Ref, forwardRef } from 'react';

export const DashedSquareInOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M22 7.2h-5.2V2H15v7h7z" fill="currentColor" />
                <path d="M2 7.2V9h7V2H7.2v5.2z" fill="currentColor" />
                <path d="M7.2 22H9v-7H2v1.8h5.2z" fill="currentColor" />
                <path d="M22 16.8V15h-7v7h1.8v-5.2z" fill="currentColor" />
            </g>
        </svg>
    )
);
DashedSquareInOutlinedSize24Glyph.displayName = 'DashedSquareInOutlinedSize24Glyph';
